import { createPortal } from 'react-dom'
import { AnimatePresence } from 'framer-motion'
import { usePreviewSheet, closePreview } from '@/hooks/usePreviewSheet'
import StudioPreviewSheet from '@/components/cards/StudioPreviewSheet'

export function PreviewSheetPortal() {
  const { data } = usePreviewSheet()

  return createPortal(
    <AnimatePresence>
      {data && <StudioPreviewSheet key={data.id} data={data} onClose={closePreview} />}
    </AnimatePresence>,
    document.body
  )
}
